import { axiosUser, axiosAdmin } from "config/axios.config";

const USER_URL = "/user";
const UPLOAD_URL = `/upload`;

const userSvc = {
  get: async (id) => {
    const response = await axiosUser.get(`${USER_URL}/${id}`);
    return response;
  },
  changePassword: async (id, body) => {
    const response = await axiosUser.post(`/auth/change_password/${id}`, body);
    return response;
  },
  update: async (id, body) => {
    const response = await axiosUser.put(`${USER_URL}/${id}`, body);
    return response;
  },

  upload: async (icon) => {
    const formData = new FormData();
    formData.append("image", icon);
    console.log(formData);
    const response = await axiosAdmin.post(UPLOAD_URL, formData, {
      "Content-Type": "multipart/form-data",
      // "Access-Control-Allow-Credentials": true
      // headers: { "Content-Type": "multipart/form-data", 'Access-Control-Allow-Origin': '*' }
    });
    return response;
  },
  checkAggrementTnC: async (id, params) => {
    const response = await axiosUser.get(`${USER_URL}/agreement-tnc/${id}`, 
      {
        params
      }
    );
    return response;
  },
  recordAggrementTnC: async (id, params) => {
    const response = await axiosUser.post(`${USER_URL}/agreement-tnc/${id}`, null, 
      {
        params
      }
    );
    return response;
  },
};

export default userSvc;
